export const personalizedLearning = {
  'ISTJ': {
    preferredEnvironment: ['安静有序', '结构清晰', '独立空间'],
    learningMethods: ['系统学习', '实践练习', '逐步掌握'],
    studyHabits: ['制定详细计划', '记录和复习', '定期评估'],
    toolsAndResources: ['学习管理系统', '笔记工具', '专业书籍'],
    challenges: ['适应变化', '创新思维', '团队协作'],
    improvements: [
      '尝试新的学习方法',
      '参与小组讨论',
      '培养创造性思维'
    ]
  },
  // ... 其他类型的学习建议
}

export const learningStyles = {
  E: {
    preferredMethods: ['小组讨论', '互动学习', '实践演练'],
    challenges: ['独立学习', '长时间专注', '理论学习'],
    suggestions: ['组织学习小组', '边做边学', '通过教授他人学习']
  },
  I: {
    preferredMethods: ['独立阅读', '深度思考', '自主学习'],
    challenges: ['即时回应', '群体讨论', '公开展示'],
    suggestions: ['预留思考时间', '做好预习', '记录思考过程']
  },
  // ... 其他维度的学习风格
} 